import React from 'react';
import $ from "jquery";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Button } from 'semantic-ui-react';
import makeDeceimalPoints from '../../makedecimalpoints';
import Server from '../../../functions/server';
import Loading from '../../loadings';
import ReadCookie from '../../../functions/readcookies';
import AddSpares from './addsparesincombo';

const styles = { appBar: { position: 'relative', }, flex: { flex: 1, }, };

function Transition(props) { return <Slide direction="up" {...props} />; }

class ViewComboSpares extends React.Component {

  state = {
    comboSpares: []
  }

  viewComboSpares(id) {
    let context = this;
    this.setState({ load: true, message: 'Getting Combo Spares!!!!' });
    $.ajax({
        type: 'POST', data: { id },
        url: Server() + 'combo/getcombospares.php',
        success: function(data) {
            context.setState({ load: false })
            try {
                data = JSON.parse(data);
                context.setState({ comboSpares: data, openComboSparesDialog: true })
            } catch (error) {
                alert('Error')
            }
          context.setState({ load: false })
        },
        error: function(err) {
          context.setState({ load: false });
          alert('Try again!!!')
        }
      });
  }

  deleteSpares(id) {
    let context = this;
    context.setState({ load: true, message: 'Deleting Spare!!!' })
    $.ajax({
        type: 'POST', data: { id },
        url: Server() + 'combo/deletespareincombo.php',
        success: function(data) {
            context.setState({ load: false })
            if (data == 1) {
                context.viewComboSpares(context.props.id);
            }
            else {
                alert('error')
            }
        },
        error: function(err) {
          context.setState({ load: false });
          alert('Try again!!!')
        }
      });
  }

  convertIntoNumber(value) {
    try {
        value = Number(value);
    } catch (error) {
        value = 0;
    }
    return value;
  }

  render() {
    const { classes } = this.props;
    let sino = 1;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <center onClick={this.viewComboSpares.bind(this, this.props.id)}>View</center>
        
        <Dialog fullScreen
          open={this.state.openComboSparesDialog} onClose={ () => { this.setState({ openComboSparesDialog: false }) }}
          TransitionComponent={Transition}>
          <AppBar  className={classes.appBar}>
            <Toolbar>
              <IconButton color="inherit" onClick={ () => { this.setState({ openComboSparesDialog: false }) }} aria-label="Close"> <CloseIcon />
              </IconButton>
              <Typography variant="h6" color="inherit" className={classes.flex}>{this.props.name}</Typography>
            </Toolbar>
          </AppBar>
          
          <div style={{margin: '10px', width: '100%'}}>
            <AddSpares reloadComboSpares={this.viewComboSpares.bind(this, this.props.id)} comboSpares={this.state.comboSpares} id={this.props.id} />
            <table id="table" width="100%">
                <tr>
                    <th>Sino</th>
                    <th>Partno</th>
                    <th>Spare Name</th>
                    <th>Model</th>
                    <th>Category</th>
                    <th>Units</th>
                    <th>Mrp</th>
                    <th>Total</th>
                    <th>Dis(%)</th>
                    <th>Dis Rs</th>
                    <th>Price</th>
                    <th>Delete</th>
                    
                </tr>
                {
                    this.state.comboSpares.map((c) => {
                        let unit = this.convertIntoNumber(c.units);
                        let mrp = this.convertIntoNumber(c.mrp);

                        return (
                            <tr>
                                <td>{sino++}</td>
                                <td>{c.partno}</td>
                                <td>{c.spare_name}</td>
                                <td>{c.model_name}</td>
                                <td>{c.category_name}</td>
                                <td><center>{c.units}</center></td>
                                <td><div style={{textAlign: 'right'}}>{makeDeceimalPoints(mrp)}</div></td>
                                <td><div style={{textAlign: 'right'}}>{makeDeceimalPoints(mrp * unit)}</div></td>
                                <td><center>{c.discountper}</center></td>
                                <td><div style={{textAlign: 'right'}}>{makeDeceimalPoints(this.convertIntoNumber(c.discountrs))}</div></td>
                                <td><div style={{textAlign: 'right'}}>{makeDeceimalPoints(this.convertIntoNumber(c.price))}</div></td>
                                <td><center style={{color: 'red'}} onClick={this.deleteSpares.bind(this, c.id)}>Delete</center></td>
                            </tr>
                        )
                    })
                }
            </table>
          </div>
        </Dialog>
      </div>
    );
  }
}

ViewComboSpares.propTypes = { classes: PropTypes.object.isRequired, };

export default withStyles(styles)(ViewComboSpares);